import React, { useRef, useState, useEffect, useContext } from "react";
import HTMLFlipBook from "react-pageflip";
import { useLocation, useNavigate } from "react-router-dom";
import { FILE_URL } from "../../constants/Constants";
import { updateBookPdfProgress } from "../../api";
import { AuthContext } from "../../context";
import { IMAGES } from "../../assets";

const flipSound = new Audio(
  "https://ebook.prometteur.in/front/static/media/page-flip.47d6f47e1cc6783855bd.mp3"
);
const ImpressiveRead = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const bookPdfItem = location?.state?.bookPdfItem;
  const pageNum = location?.state?.pageNum || 1;

  const [pages, setPages] = useState(
    location?.state?.bookPdfItem?.bookPdfImage
  );

  useEffect(() => {
    impressivePages();
  }, [location]);

  const impressivePages = () => {
    const updatedImage = location?.state?.bookPdfItem?.bookPdfImage.map(
      (ele) => `${FILE_URL}${ele}`
    );
    setPages(updatedImage);
  };

  const flipBookRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(pageNum);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    if (flipBookRef.current) {
      setTotalPages(pages.length);
      flipBookRef?.current?.pageFlip()?.turnToPage(pageNum);
    }
  }, [flipBookRef, pages, pageNum]);

  const onFlip = (e) => {
    flipSound.play();
    setCurrentPage(e.data);
  };

  const playFlipSound = () => {
    flipSound.play();
  };

  const goToNextPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipNext();
      // playFlipSound();
    }
  };

  const goToPrevPage = () => {
    if (flipBookRef.current) {
      flipBookRef.current.pageFlip().flipPrev();
      // playFlipSound();
    }
  };

  async function onUpdatePdfProcress(exit) {
    const params = {
      userId: user?.userInfo?._id,
      bookId: bookPdfItem?._id,
      totalPages: pages.length,
      readPages: currentPage + 1,
      bookProgress: exit ?? true,
      instituteId: user?.userInfo?.createdBy,
    };

    const result = await updateBookPdfProgress(params);
    if (!result?.status) {
      // Handle error (e.g., show a popup)
    }
  }

  const handleBackNavigate = () => {
    onUpdatePdfProcress(false);
    navigate(-1);
  };

  return (
    <>
      <div className="m-2 flex items-center justify-between bg-white sticky top-0 z-50 py-1">
        <button
          className="w-8 h-8 text-lg font-bold border-slate-400 border flex items-center justify-center rounded-full"
          onClick={handleBackNavigate}
        >
          <img
            className="w-full h-full"
            alt="backarrow"
            src={IMAGES?.backIcon}
          />
        </button>
        <div className="mx-auto">
          <h2 className="mx-auto text-lg font-bold text-center">
            {bookPdfItem?.bookName}
          </h2>

          <div className="flex items-center justify-center gap-2">
            <button
              className="h-8 w-8 rounded-full border"
              onClick={goToPrevPage}
              disabled={currentPage === 0}
            >
              <img
                alt="prev"
                className="w-full h-full"
                src={IMAGES?.backIcon}
              />
            </button>

            <span>
              {" "}
              <span className="text-base font-semibold">
                {currentPage + 1}
              </span>{" "}
              <span className="text-base font-medium text-[#8A8A8A]">
                / {totalPages}
              </span>
            </span>

            <button
              className="h-8 w-8 rounded-full border"
              onClick={goToNextPage}
              disabled={currentPage === totalPages - 1}
            >
              <img
                alt="next"
                className="w-full h-full rotate-180"
                src={IMAGES?.backIcon}
              />
            </button>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-center">
        {/* Flipbook Container */}
        <div className="relative w-full h-full flex items-center justify-center overflow-hidden mx-auto">
          <HTMLFlipBook
            ref={flipBookRef}
            width={400}
            height={600}
            size="fixed"
            minWidth={300}
            maxWidth={600}
            minHeight={400}
            maxHeight={800}
            maxShadowOpacity={0.5}
            showCover={true}
            mobileScrollSupport={true}
            onFlip={onFlip}
            startPage={pageNum}
          >
            {pages.map((page, index) => (
              <div key={index} className="page">
                <img
                  src={page}
                  alt={`page-${index}`}
                  className="w-full h-full object-contain"
                />
              </div>
            ))}
          </HTMLFlipBook>
        </div>
      </div>
    </>
  );
};

export default ImpressiveRead;
